import React, { useEffect } from 'react'
import Header from '../Header/Header'
import Nav from '../Header/Nav'
import Footer from '../Footer/Footer'
import WhatssapIcon from '../Home/WhatssapIcon'
import NosProductsPage from './NosProductsPage'

const NosProducts = () => {

  useEffect(() => {
    // This is more reliable for sticky headers
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
    });
}, []);


  return (
    <div>

        <Header />

        <Nav target="nos-produits" />



        <NosProductsPage />


        <WhatssapIcon/>

        <Footer />



    </div>
  )
}

export default NosProducts